import React, { useState } from 'react';
import { Button } from './ui/button';
import { Menu, X } from 'lucide-react';
import { useNavigate, useLocation } from 'react-router-dom';

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  const scrollToSection = (sectionId) => {
    if (location.pathname !== '/') {
      navigate('/');
      setTimeout(() => {
        const element = document.getElementById(sectionId);
        if (element) {
          element.scrollIntoView({ behavior: 'smooth' });
        }
      }, 100);
    } else {
      const element = document.getElementById(sectionId);
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
      }
    }
    setIsMenuOpen(false);
  };

  const goToNews = () => {
    navigate('/noticias');
    setIsMenuOpen(false);
  };

  return (
    <header className="header-fixed">
      <div className="header-container">
        <div className="header-logo" onClick={() => navigate('/')} style={{cursor: 'pointer'}}>
          <img src="/images/logo/logo.png" alt="Elite Internacional" className="logo-image" />
        </div>

        {/* Desktop Navigation */}
        <nav className="nav-desktop">
          <button onClick={() => scrollToSection('hero')} className="nav-link">Inicio</button>
          <button onClick={() => scrollToSection('about')} className="nav-link">Quiénes Somos</button>
          <button onClick={() => scrollToSection('services')} className="nav-link">Servicios</button>
          <button onClick={() => scrollToSection('players')} className="nav-link">Jugadores</button>
          <button onClick={() => scrollToSection('why-elite')} className="nav-link">Por Qué Elite</button>
          <button onClick={goToNews} className="nav-link">Noticias</button>
          <Button onClick={() => scrollToSection('contact')} className="btn-primary">Contacto</Button>
        </nav>

        {/* Mobile Menu Button */}
        <button
          className="mobile-menu-btn"
          onClick={() => setIsMenuOpen(!isMenuOpen)}
          aria-label="Toggle menu"
        >
          {isMenuOpen ? <X size={24} /> : <Menu size={24} />}
        </button>
      </div>

      {/* Mobile Navigation */}
      {isMenuOpen && (
        <nav className="nav-mobile">
          <button onClick={() => scrollToSection('hero')} className="nav-link-mobile">Inicio</button>
          <button onClick={() => scrollToSection('about')} className="nav-link-mobile">Quiénes Somos</button>
          <button onClick={() => scrollToSection('services')} className="nav-link-mobile">Servicios</button>
          <button onClick={() => scrollToSection('players')} className="nav-link-mobile">Jugadores</button>
          <button onClick={() => scrollToSection('why-elite')} className="nav-link-mobile">Por Qué Elite</button>
          <button onClick={goToNews} className="nav-link-mobile">Noticias</button>
          <button onClick={() => scrollToSection('contact')} className="nav-link-mobile">Contacto</button>
        </nav>
      )}
    </header>
  );
};

export default Header;